class EditorialGallery extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    this.stage = this.querySelector('[data-gallery-stage]');
    if (!this.dialog?.showModal) return;
    this.querySelectorAll('[data-gallery-open]').forEach(button => { button.disabled = false; });
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-gallery-open]');
      if (button) this.open(button);
      if (event.target.closest('[data-gallery-close]')) this.close();
      if (this.backdropPressed && event.target === this.stage) this.close();
      this.backdropPressed = false;
    }, { signal });
    this.dialog.addEventListener('pointerdown', event => { this.backdropPressed = event.target === this.stage; }, { signal });
    this.dialog.addEventListener('cancel', event => {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }, { signal });
    this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.finishClose(); }, { signal });
    for (const name of ['cart:opening', 'header:opening', 'quick-add:ready']) {
      document.addEventListener(name, () => this.close(false), { signal });
    }
    this.addEventListener('shopify:block:select', event => {
      this.close(false);
      event.target.closest('[data-gallery-tile]')?.scrollIntoView({ block: 'center', behavior: 'instant' });
    }, { signal });
    this.motionPromise = import(this.dataset.motionUrl).then(module => { this.motion = module; }).catch(() => {});
  }

  open(button) {
    if (document.querySelector('dialog[open], .store-header [data-menu-branch][open], .store-header [data-header-search][open]') || document.documentElement.hasAttribute('data-privacy-overlay')) return;
    const template = button.closest('[data-gallery-tile]')?.querySelector('template');
    if (!template) return;
    this.trigger = button;
    this.restoreFocus = true;
    this.stage.replaceChildren(template.content.cloneNode(true));
    this.dialog.showModal();
    this.querySelector('[data-gallery-close]').focus({ preventScroll: true });
    this.motion?.revealDialog(this.dialog);
  }

  close(restore = true) {
    if (!this.dialog?.open) return;
    this.restoreFocus = restore;
    this.stage.querySelector('video')?.pause();
    if (restore && this.motion) this.motion.dismissDialog(this.dialog, () => this.dialog.close());
    else {
      this.motion?.cancelDialogMotion(this.dialog);
      this.dialog.close();
    }
    if (!restore) this.finishClose();
  }

  finishClose() {
    this.motion?.cancelDialogMotion(this.dialog);
    this.stage.querySelector('video')?.pause();
    this.stage.replaceChildren();
    if (this.restoreFocus && this.trigger?.isConnected && !document.querySelector('dialog[open]')) {
      this.trigger.focus({ preventScroll: true });
    }
    this.trigger = null;
  }

  disconnectedCallback() {
    this.close(false);
    this.controller?.abort();
  }
}

if (!customElements.get('editorial-gallery')) customElements.define('editorial-gallery', EditorialGallery);
